import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "@/lib/api";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { BellRing } from "lucide-react";

const SESSION_KEY = "gc_delivery_alert_seen";

export default function DeliveryAlert() {
  const [alerts, setAlerts] = useState([]);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (sessionStorage.getItem(SESSION_KEY) === "1") return;
    api
      .get("/deliveries")
      .then((r) => {
        const a = r.data?.alerts || [];
        if (a.length > 0) {
          setAlerts(a);
          setOpen(true);
        }
      })
      .catch(() => {});
  }, []);

  const close = () => {
    sessionStorage.setItem(SESSION_KEY, "1");
    setOpen(false);
  };

  if (alerts.length === 0) return null;

  return (
    <Dialog open={open} onOpenChange={(o) => !o && close()}>
      <DialogContent className="sm:max-w-md" data-testid="delivery-alert-dialog">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2 font-heading">
            <BellRing className="w-5 h-5 text-gold-500" /> Delivery reminders
          </DialogTitle>
        </DialogHeader>
        <ul className="space-y-3 mt-2">
          {alerts.map((a) => (
            <li key={a.order_id} className="border-l-2 border-zinc-900 pl-3">
              <div className="text-xs text-zinc-500">
                {a.when === "today" ? (
                  <span className="text-red-700 font-semibold">Delivery is TODAY</span>
                ) : (
                  <span className="text-amber-700 font-semibold">Delivery scheduled for TOMORROW</span>
                )}
              </div>
              <Link
                to={`/orders/${a.order_id}`}
                onClick={close}
                className="block font-medium text-sm hover:underline"
              >
                <span className="font-mono text-xs text-zinc-400 mr-1">{a.order_no}</span>
                {a.title}
              </Link>
              <div className="text-xs text-zinc-500">
                {new Date(a.expected_delivery).toLocaleString()}
              </div>
            </li>
          ))}
        </ul>
        <DialogFooter>
          <Link to="/deliveries" onClick={close}>
            <Button variant="outline" data-testid="delivery-alert-view-all">View all deliveries</Button>
          </Link>
          <Button className="bg-zinc-900 hover:bg-zinc-800" onClick={close} data-testid="delivery-alert-dismiss">
            Got it
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
